export default "__VITE_ASSET__BZk3sisG__"